module.exports = __webpack_public_path__ + "assets/2h.d7846445.svg";